<template>
<div class="pagination-container bg-dark">
  <div class="container-fluid almost-fluid">
    <div class="row">
      <div class="col">
        <nav>

          <a @click.prevent="setPage(1)">&laquo;</a>

          <a @click.prevent="setPage(page - 1)">&lsaquo;</a>

          <input type="number"
                  class="form-control form-control-sm"
                  v-model="inputVal"
                  @keyup.enter="setPage(inputVal)"
                  @blur="setPage(inputVal)">

          <small>/</small>

          <small>{{ pageCount }}</small>

          <a @click.prevent="setPage(page + 1)">&rsaquo;</a>

          <a @click.prevent="setPage(pageCount)">&raquo;</a>

        </nav>
      </div>
      <div class="col">

        <small class="pull-right">{{ 'TOTAL_ROWS' | translate }}: {{ itemCount }}</small>

      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    pageCount: { default: 1 },
    itemCount: { default: 1 }
  },
  data() {
    return {
      page: parseInt(this.currentPage),
      inputVal: parseInt(this.currentPage)
    }
  },
  methods: {
    setPage(pageNum) {
      if (pageNum > this.pageCount) {
        this.updatePageValues(this.pageCount);
      } else if (pageNum < 1) {
        this.updatePageValues(1);
      } else {
        this.updatePageValues(pageNum);
      }
    },
    updatePageValues(pageNum) {
      this.page = parseInt(pageNum);
      this.inputVal = parseInt(pageNum);
    }
  },
  watch: {
    page(val) {
      this.$emit('input', val);
    },
    pageCount(val) {
      if (this.page > val) this.updatePageValues(val);
      else if (this.page < 1) this.updatePageValues(1); // handle case when filters have been cleared after 0 results
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-container {
  position: fixed;
  z-index: 5;
  right: 0;
  bottom: 0;
  left: 0;
  padding: .75rem 0;
  height: 2.75rem;
  nav > * {
    float: left;
    height: 20px;
    vertical-align: middle;
    text-align: center;
  }
  a {
    margin: 0 2px;
    display: inline-block;
    width: 12px;
    font-size: 1.5rem;
    line-height: 1rem;
    color: $white;
    cursor: pointer;
    &:hover {
      color: $light;
    }
  }
  input {
    margin: 0 5px;
    padding: .25rem;
    display: inline-block;
    width: 64px;
    font-size: 80%;
  }
  small {
    margin: 0 5px;
    font-weight: 500;
    line-height: 1.3rem;
    color: $white;
  }
  a + input,
  small + a {
    margin-left: 16px;
  }
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue